<script lang="ts">
	import { Input, Text, Button, Container } from '@Shelly/shelly-design-system';
	import { convertTime, getErrorOrInfoMessageForMinAndMax } from 'src/helpers/utilities';
	import { callBluTRV, getTrvComponentByDevice } from 'src/helpers/virtual_helpers/blutrv_helpers';
	import type { Device } from 'src/types/Device';
	import { format } from 'svelte-i18n';

	export let device: Device;
	let waitForResponse = false;

	let defaultDuration = getTrvComponentByDevice(device)?.config?.['trv:0']?.default_boost_duration;
	let value = typeof defaultDuration !== 'undefined' ? convertTime(defaultDuration, 'seconds') : 0;

	$: minMaxInfo = getErrorOrInfoMessageForMinAndMax(Number(value), 0, 35791394, false, true);

	const handleDuration = async () => {
		if (value === '') {
			value = 0;
		}
		waitForResponse = true;

		await callBluTRV(device, 'Trv.Setconfig', {
			id: 0,
			config: { default_boost_duration: convertTime(value, 'minutes') },
		});
		waitForResponse = false;
	};
</script>

<div class="d-flex flex-direction-column">
	<Text element="span" styleType="body-extra-small"
		>{$format('text_trv_setting_duration', { default: 'Duration' })}</Text
	>

	<Input
		aria-label={$format('input_blu_trv_boost_duration', {
			default: 'Enter the boost duration. Value must be between {min} — {max}!',
			values: { min: 0, max: 35791394 },
		})}
		icon="fas fa-calculator"
		size="m"
		class="width-lg-l width-sm-full mb-s"
		info={$format('input_blu_trv_boost_duration', {
			default: 'Override the default boost duration in minutes',
		})}
		error={minMaxInfo.error}
		bind:value
		id="input-jacrlnb"
	/>

	<Button
		loading={waitForResponse}
		disabled={minMaxInfo.error || waitForResponse}
		class="mt-s"
		size="m"
		width="full"
		on:click={handleDuration}
		>{$format('button_save_settings', {
			default: 'Save settings',
		})}</Button
	>
</div>
